const SET = 'formlabs/specTable/SET';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET:
      return { ...state, [action.payload.table]: action.payload.column };
    default:
      return state;
  }
}

export const setActiveColumn = (table, column) => {
  return {
    type: SET,
    payload: {
      table,
      column
    }
  };
};
